import {
  useRef,
  useLayoutEffect,
  useEffect,
  useState,
  useCallback,
} from "react";

export default function useFlipDraggableAnimation() {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  const containerCallbackRef = useCallback((node: HTMLDivElement | null) => {
    setContainer(node);
  }, []);

  const prevPositions = useRef<Map<string, DOMRect>>(new Map());

  useEffect(() => {
    if (!container) return;
    const childrenElements = Array.from(
      container.querySelectorAll<HTMLElement>("[data-draggable-id]"),
    );
    childrenElements.forEach((node) => {
      const draggableId = node.dataset.draggableId!;
      const newRect = node.getBoundingClientRect();
      prevPositions.current.set(draggableId, newRect);
    });
  }, [container]);

  useLayoutEffect(() => {
    if (!container) return;
    const childrenElements = Array.from(
      container.querySelectorAll<HTMLElement>("[data-draggable-id]"),
    );
    childrenElements.forEach((node) => {
      const newRect = node.getBoundingClientRect();
      const draggableId = node.dataset.draggableId!;

      const prevRect = prevPositions.current.get(draggableId);
      if (prevRect) {
        // Calculate the delta between the previous and new position
        const deltaX = prevRect.left - newRect.left;
        const deltaY = prevRect.top - newRect.top;
        if (deltaX !== 0 || deltaY !== 0) {
          // Invert: immediately apply the transform
          node.style.transition = "none";
          node.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

          // Play: remove the transform so that it animates to its new position
          requestAnimationFrame(() => {
            node.style.transition = "transform 300ms ease";
            node.style.transform = "";
          });
        }
      }
      // Store the new position for the next update
      prevPositions.current.set(draggableId, newRect);
    });
  });
  return containerCallbackRef;
}
